import {Component, Input, OnInit, Output, EventEmitter, inject, SimpleChanges, OnChanges} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  FormGroupDirective,
  ReactiveFormsModule,
} from '@angular/forms';

import {faChevronUp, faChevronDown, faBars, faXmark} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {ContentService} from "../../../../../admin/data-access/content.service";
import {CCL, ProblemTemplate, Question, Subject} from "../construct.component";
import {PoolQuestionsComponent} from "./pool-questions/pool-questions.component";
import { DropdownSearchComponent } from 'src/app/shared/ui/dropdown-search/dropdown-search.component';
import {FullButtonComponent} from "../../../../../shared/ui/full-button/full-button.component";
import {
  LearningObjective
} from "../../../../../admin/feature/contentViewer/learningObjective/learningObjective.component";
import {OutlineButtonComponent} from "../../../../../shared/ui/outline-button/outline-button.component";
import { DeleteConfirmationComponent } from "src/app/shared/ui/delete-confirmation/delete-confirmation.component";

@Component({
    selector: 'assessment-questions',
    templateUrl: './assessment-questions.component.html',
    styleUrls: ['../../../../../admin/feature/userManagement/userRoleAddEdit/userRoleAddEdit.css', '../construct.component.css'],
    imports: [ReactiveFormsModule, FontAwesomeModule, DropdownSearchComponent, PoolQuestionsComponent,
      FullButtonComponent, OutlineButtonComponent, DeleteConfirmationComponent]
})
export class AssessmentQuestionsComponent implements OnInit, OnChanges {
  constructor(private contentService: ContentService) {}
  @Input() subject_ids: Subject[] = []
  @Input() ccl_ids: CCL[] = []
  faChevronUp = faChevronUp
  faChevronDown = faChevronDown
  faBars = faBars
  faXmark = faXmark
  @Input() part_index!: number
  @Input() allProblemTemplates: ProblemTemplate[] = []
  @Output() allProblemTemplatesChange = new EventEmitter<ProblemTemplate[]>()
  @Input() allSubjectsAdded: Subject[] = []
  @Output() allSubjectsAddedChange = new EventEmitter<Subject[]>()
  @Input() addedLearningObjective: LearningObjective[] = []
  @Output() addedLearningObjectiveChange = new EventEmitter<LearningObjective[]>()
  rootFormGroup = inject(FormGroupDirective);
  @Input() formGroupName!: string;
  questionFormSection!: FormArray;
  poolIter = 0
  showQuestionPoolInfoDialog: boolean = false;

  ngOnInit() {
    this.questionFormSection = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormArray;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['subject_ids']) {
      //this.listByCCLs();
    }
    this.addedLearningObjective.concat(this.addedLearningObjective)
    this.addedLearningObjectiveChange.emit(this.addedLearningObjective)
  }

  get part(): FormGroup {
    return this.questionFormSection.at(this.part_index) as FormGroup
  }

  get qpools(): FormArray {
    return this.part.get('qpools') as FormArray
  }

  addNewPool(index: number) {
    const pool: FormGroup = new FormGroup({
      // examqpool_id is handled by the backend
      examqpool_id: new FormControl(null),
      exampart_id: new FormControl(this.part.get('exampart_id')?.value),
      qpool_position: new FormControl(this.qpools.length + 1),
      presentation_order: new FormControl('LINEAR'),
      // score per question need to be tracked, add input on qpool and remove the input on the individual questions
      questions_used: new FormControl(null),
      score_per_question: new FormControl(null),
      expanded: new FormControl(true),
      questions: new FormArray([])
    })
    this.qpools.push(pool)
    this.poolIter += 1
    this.listByCCLs();
  }

  listByCCLs() {
    let tempIDs: number[] = []
    for(let id of this.subject_ids)
      tempIDs.push(id.subject_id)
    for(let id of this.ccl_ids)
      tempIDs.push(id.customcontentlayer_id)
    // TODO check if subject has CCLs
    /*this.contentService.listByCCLs(tempIDs).subscribe((response) => {
      if(response.success) {
        this.allProblemTemplates = response.result
      } else {
        this.allProblemTemplates = [];
      }
    })*/
  }

  scoreChange(event: Event, pool: AbstractControl) {
    pool.get('score_per_question')?.setValue((event.target as HTMLInputElement).valueAsNumber)
  }

  questionsUsedChange(event: Event, pool: AbstractControl) {
    const questions = pool.get('questions') as FormArray
    if((event.target as HTMLInputElement).value !== '')
      pool.get('questions_used')?.setValue(((event.target as HTMLInputElement).valueAsNumber))
    else
      pool.get('questions_used')?.setValue(questions.length)
  }

  showConfirmRemovePoolDialog = false
  qPoolToBeDeletedIter = -1
  qPoolsToBeDeleted: FormArray | null = null

  showConfirmRemovePool(iter: number, qPools: FormArray) {
    this.qPoolToBeDeletedIter = iter
    this.showConfirmRemovePoolDialog = true
    this.qPoolsToBeDeleted = qPools
  }

  removePool() {
    if(this.qPoolsToBeDeleted) {
      this.qPoolsToBeDeleted.removeAt(this.qPoolToBeDeletedIter)
    }
    this.showConfirmRemovePoolDialog = false
  }

  // TODO need to emit the pools change when PTs are chosen or values are placed
  protected readonly FormControl = FormControl;
}
